export const TOKEN = {
  access: 'access-token',
  refresh: 'refresh-token',
};

export enum TypeAdmin {
  MARKETER,
  ADMIN,
}
